var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFile = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.429 1h12.137L22 7.168v14.457c0 .76-.64 1.375-1.429 1.375H3.43C2.64 23 2 22.385 2 21.625V2.375C2 1.615 2.64 1 3.429 1Z",
  fill: "#FEC532"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.98 7.188H17c-.788 0-1.428-.616-1.428-1.375V1.014l6.407 6.174Z",
  fill: "#E4A501"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.152 16.176h-2.25V18.5H4.73v-5.688h3.704v.95H5.902v1.468h2.25v.946ZM10.36 18.5H9.187v-5.688h1.171V18.5ZM12.621 17.559h2.488v.941h-3.66v-5.688h1.172v4.747ZM19.207 16.035h-2.25v1.524h2.64v.941h-3.812v-5.688h3.805v.95h-2.633v1.355h2.25v.918Z",
  fill: "#fff"
})));
export default SvgFile;